<template>
  <div
    :class="`ims-sidemenu-container ${visible ? 'visible' : 'hidden'}`"
    @click="backgroundClicked()"
  >
    <div
      class="ims-sidemenu"
      v-on:click.stop
    >
      <ims-toolbar
        class="header"
        :inverse="true"
        :style="backgroundStyle"
      >
        <template v-slot:left>
          <ims-button
            class="btn-icon close-button"
            type="clear"
            @click="$store.dispatch('interact/sidemenu/toggle')"
          >
            <ims-icon
              icon="close"
              color="white"
            />
          </ims-button>
        </template>
        <div class="title md">
          {{ $store.state.brand.name }}
          <div class="note ">{{ $store.state.brand.gameName }}</div>
        </div>
      </ims-toolbar>
      <main
        class="pt-3"
        :style="backgroundStyle"
      >
        <!-- Main Content Area -->
        <ims-item
          v-if="$User.isLoggedIn()"
          detail="true"
          class="pad"
          @click="
            $store.dispatch('interact/modals/profile/toggle');
            toggle();
          "
        >
          <h1 v-if="(this.$User.profile || {}).teamName">
            {{ this.$User.profile.teamName }}
          </h1>
          <h1 v-else-if="(this.$User.profile || {}).firstName">
            {{ this.$User.profile.playerName }}
          </h1>
          <h1 v-else>Welcome</h1>
          <div
            class="note opacity-5"
            v-if="(this.$User.profile || {}).firstName"
          >
            ({{ this.$User.profile.firstName }}
            {{ this.$User.profile.lastName }})
          </div>
          <div
            class="note opacity-9"
            v-else
          >Create your Profile</div>
        </ims-item>

        <div class="p-2" />

        <ims-item
          v-if="$User.account"
          detail="true"
          @click="toggle()"
          to="/home"
          class="text-sm"
        >Home</ims-item>

        <ims-item
          detail="true"
          class="text-sm"
          v-if="!$User.loggedIn"
          @click="
            $store.dispatch('user/login');
            toggle();
          "
        >
          Sign up / Login
        </ims-item>

        <ims-item
          :href="`${$store.state.brand.urlRules}`"
          v-on:click="toggle()"
          class="text-sm"
          detail="true"
        >Official Game Rules</ims-item>

        <ims-item
          :href="`${$store.state.brand.urlFAQs}`"
          class="text-sm"
          @click="toggle()"
          detail="true"
        >FAQs</ims-item>

        <ims-item
          :href="`${$store.state.brand.urlScoring}`"
          class="text-sm"
          @click="toggle()"
          detail="true"
        >Scoring System</ims-item>

        
          <ims-item
          :href="`https://www.indycar.com/support`"
          xtarget="_blank"
          detail="true"
          v-on:click="toggle()"
          class="text-sm"
        >
          Help / Feedback
          <!-- <template v-slot:right>
            <ims-icon icon="open_in_new" />
          </template> -->
        </ims-item>

        <ims-item
          :href="`${$store.state.brand.urlTerms}`"
          xtarget="_blank"
          detail="true"
          v-on:click="toggle()"
          class="text-sm"
        >
          Terms of Service
          <!-- <template v-slot:right>
            <ims-icon icon="open_in_new" />
          </template> -->
        </ims-item>

        <ims-item
          :href="`${$store.state.brand.urlPrivacy}`"
          xtarget="_blank"
          detail="true"
          v-on:click="toggle()"
          class="text-sm"
        >
          Privacy Policy
          <!-- <template v-slot:right>
            <ims-icon icon="open_in_new" />
          </template> -->
        </ims-item>

        <div class="p-2" />

        <ims-item
          class="text-sm"
          v-on:click="doLogout()"
          v-if="$User.account && this.$store.getters['isStandalone']"
        >Logout</ims-item>
        <!-- end Main Content -->
        <!-- Uncomment to show bearer token -->
        <!-- <div
          class="py-3 px-3 text-faded text-xs"
          v-if="this.$store.state.user.passedBearer"
        >
          ICBT:
          <strong>{{
            this.$store.state.user.passedBearer.substr(0, 20)
          }}</strong>
        </div> -->
        <!-- Uncomment to show standalone flag -->
        <!-- <div
          class="py-3 px-3 text-faded text-xs"
          v-if="$store.getters.isStandalone"
        >Standalone</div> -->
      </main>

      <ims-toolbar
        class="footer"
        :style="backgroundStyle"
      >
        <div class="w-100">
          <div class="text-sm text-faded">
            v{{ version }} - &copy; Copyright {{new Date().getFullYear()}}
          </div>
          <div class="text-sm text-white">Brickyard Trademarks, Inc.</div>
        </div>
      </ims-toolbar>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    visible() {
      return this.$store.state.interact.sidemenu.show;
    },
    user() {
      return this.$store.state.user.user;
    },
    version() {
      return process.env.VUE_PACKAGE_VERSION;
    },
    backgroundStyle() {
      return `background-color:${this.$store.state.brand.color} !important;`;
    }
  },
  methods: {
    deleteAllCookies() {
      this.toggle();
      this.$store.dispatch('interact/popmenu', {
        title: 'Delete all cookies?',
        description: 'This will remove all cookies and log you out.',
        buttons: [
          {
            title: 'Yes, delete cookies',
            click: () => {
              this.$store.dispatch('user/clear/everything');
            }
          }
        ]
      });
    },
    doLogout() {
      this.toggle();
      this.$store.dispatch('user/logout');
    },
    backgroundClicked() {
      this.$store.dispatch('interact/sidemenu/hide');
    },
    toggle() {
      this.$store.dispatch('interact/sidemenu/toggle');
    }
  }
};
</script>

<style lang="scss">
@import '../../scss/utils/variables';
@import '../../scss/vendors/bootstrap-utils';

.ims-sidemenu-container {
  $baseColor: darken($primary, 8%);
  transition: all 0.2s ease-in-out;

  &.hidden {
    opacity: 0;
    pointer-events: none;

    .ims-sidemenu {
      transform: translateX(-200px);
    }
  }

  .ims-list-item {
    background-color: transparent;
    color: #fff;
    p {
      opacity: 0.6;
    }
    .item-end {
      .ims-icon {
        color: rgba(255, 255, 255, 0.2) !important;
      }
    }
  }

  .ims-sidemenu {
    transition: all 0.2s ease-in-out;
    display: flex;
    flex-direction: column;
    height: 100%;
    flex-grow: 1;
    flex-shrink: 1;

    .router-link-active {
      background-color: rgba(0, 0, 0, 0.5);
    }

    .header,
    .footer,
    main {
      background-color: $baseColor !important;
    }
    main {
      flex-grow: 1;
      flex-shrink: 1;
      overflow-y: auto;
    }
  }

  @include media-breakpoint-up(md) {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
    width: $size-sidemenu-width !important;
    .close-button {
      display: none;
    }
    &.hidden {
      opacity: 1;
      pointer-events: all;
      .ims-sidemenu {
        transform: none;
      }
    }
  }

  @include media-breakpoint-down(sm) {
    background-color: rgba(0, 0, 0, 0.8);
    z-index: $zindex-popover;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    .ims-sidemenu {
      width: $size-sidemenu-width;
      background-color: #fff;
    }
  }
} // end sidemenu container
</style>
